import axios from "axios";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Gallery = () => {
  const { t } = useTranslation();
  const [GalleryUser, setGalleryUser] = useState([]);

  useEffect(() => {
    const fetchPoints = async () => {
      const response = await axios.post(
        "https://cyberathon.com/silverapartment/index.php/Api/Silver_Controller/gallery_list"
      );
      setGalleryUser(response.data.data);
    };

    fetchPoints();
  }, []);

  return (
    <section className="gallery-section">
      <div className="container">
        <div className="breadcrumb-section">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div
                  className="breadcrumb-text"
                  data-aos="fade-down"
                  data-aos-duration={3000}
                >
                  <h1 style={{fontSize:"44px"}}>{t("our_gallery")}</h1>
                  <div className="bt-option">
                    <Link to="/">{t("home")}</Link>
                    <span>{t("gallery")}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          {GalleryUser.map((item, index) => (
            <div className="col-lg-4" key={index}>
              <div className="gallery-item">
                <img
                  src={`https://cyberathon.com/silverapartment/${item.images}`}
                  alt={item.alt_text || `Gallery image ${index + 1}`}
                  loading="lazy"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "5px",
                  }}
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
